export const SB_EVENT = 'sb_player_event';
export const SB_TRANSITION = 'SbPlayer--transition';
export const SB_TRANSITION_PZ = 'SbPanZoom--transition';
